import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexDivWitness } from '../Styles';
import Checkbox from './CheckBox';
import { IFormCheckBoxProps } from '../../../interfaces/inputs';

const FormCheckBox: React.FC<IFormCheckBoxProps> = ({
	checkBoxesList,
	selectedList = [],
	onChange,
	supportRadioButtonBehavior,
	className = '',
	name,
}) => {
	// @ts-ignore
	const isItemChecked = (id: string) => (selectedList ? selectedList.findIndex(item => item === id) > -1 : null);

	useEffect(() => {
		const oldList = [...selectedList];
		checkBoxesList.forEach(checkBox => {
			if (checkBox.default) {
				selectedList.push(checkBox.id);
			}
		});
		if (selectedList.length !== oldList.length) {
			onChange(selectedList);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	const { t } = useTranslation();

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>, id: any) => {
		if (event.target.checked) {
			if (supportRadioButtonBehavior) {
				selectedList.length >= 1 ? (selectedList = [id]) : selectedList.push(id);
			} else {
				selectedList.push(id);
			}
		} else {
			selectedList = selectedList.filter(item => item !== id);
		}
		onChange(selectedList);
	};

	return (
		<FlexDivWitness>
			{checkBoxesList.map((item, idx) => {
				return (
					<Checkbox
						key={idx}
						checkboxKey={`lang${item.id}`}
						onChange={e => handleChange(e, item.id)}
						isChecked={isItemChecked(item.id)}
						label={t(item.name)}
						className={className}
						name={name}
					/>
				);
			})}
		</FlexDivWitness>
	);
};

export default FormCheckBox;
